<template>
	<div class="affairs">
		<AffairsSection
			:taskList="taskList"
      		:filter="filter"
			@addTask="onAddTask"
			@editTask="onEditTask"
			@assignToManager="onAssignToManager"
      		@load-events="lazyLoadEvents"
      		@change-filter="changeFilter"
		/>

		<SimpleCalendar
			style="flex-grow: 1; margin-left: 2rem"
			:taskList="calendarEvents"
      		:filter="filter"
			@addTask="onAddTask"
			@editTask="onEditTask"
      		@period-changed="periodChanged"
		/>

		<!-- ADD EVENT -->
		<vs-prompt
			:active.sync="activePromptAddEvent"
			:title="$t('addTask')"
			:acceptText="$t('save')"
			:cancelText="$t('cancel')"
			@cancel="task.startDate = ''"
			@accept="tryAddTask()"
		>
			<div class="con-exemple-prompt mb-4">
				<vx-input-group class="mb-3">
					<div
						class="vs-component vs-con-input-label vs-input vs-input-primary"
					>
						<label class="vs-input--label">{{ $t('chooseDate') }}</label>
						<div class="vs-con-input"></div>
						<vs-datepicker
							v-model="task.startDate"
							format="dd.MM.yyyy"
							v-validate="'required'"
							:to="minDate"
							name="date"
							type="datetime"
							:key="'createAffairPopupDate' + createAffairPopupKey"
						></vs-datepicker>
					</div>
					<span v-if="errors.first('date')" class="text-danger text-sm">
						{{ $t('fieldFilledIncorrect') }}
					</span>
				</vx-input-group>
				<div class="vs-component vs-con-input-label vs-input vs-input-primary ">
					<label class="vs-input--label">{{ $t('description') }}</label>
					<div class="vs-con-input"></div>
					<vs-textarea
						v-model="task.description"
						name="about"
						v-validate="'required|min:3|max:300'"
						rows="4"
						class="mb-0"
						:key="'createAffairPopupDateText' + createAffairPopupKey"
					/>
				</div>
				<span v-if="errors.first('about')" class="text-danger text-sm">
					{{ $t('fieldFilledIncorrect') }}
				</span>
			</div>
		</vs-prompt>

		<vs-popup classContent="create-appeal" class="primary-popup" :title="$t('taskView')" :active.sync="activePromptEditEvent">
			<div class="my-4">
				<b>{{$t('date')}}</b>

				<p>{{taskDueDate}}</p>
			</div>

			<div v-if="task && task.order && task.order.id" class="my-4">
				<b>{{ $t('ticket') }}</b>

				<p>
					<RouterLink :to="`/ticket/${task.order.id}`">
						<span @click.stop="activePromptEditEvent = false">
							{{ task.order.id }}
						</span>
					</RouterLink>
				</p>
			</div>

			<div class="my-4">
				<b>{{ $t('description') }}</b>
				<p>{{task.description}}</p>
			</div>

			<div class="buttons-block" style="display: flex; justify-content: flex-end;">
				<vs-button
					v-if="canShowAssignButton"
					style="margin-right: 1rem;"
					@click="showAssignTaskToManager"
					color="primary"
				>{{ $t('assign') }}</vs-button>

				<vs-button
					v-if="$store.getters['isAdmin'] ||  !task.is_by_admin"
					style="margin-right: 1rem;"
					@click="removeTask"
					color="danger"
				>{{ $t('delete') }}</vs-button>

				<vs-button
					v-if="canShowDoneButton"
					color="success"
					@click="setTaskCompleted(task), activePromptEditEvent = false"
				>{{ $t('done') }}</vs-button>
			</div>
		</vs-popup>

		<vs-prompt
			class="assign-manager-to-task"
			:title="$t('chooseManager')"
			:accept-text="$t('assign')"
			:cancel-text="$t('cancel')"
			@accept="assignToManager"
			:is-valid="!!assignedManager"
			:active.sync="activePromptAssignToManager"
    >
			<div class="my-4" />

			<v-select
				v-model="assignedManager"
				:placeholder="$t('chooseManager')"
				name="area"
				:options="managersList.map(item => buildManagerForSelect(item))"
				:label="'username'"
				:dir="$vs.rtl ? 'rtl' : 'ltr'"
			/>
		</vs-prompt>
	</div>
</template>

<script>
import SimpleCalendar from "@/components/affairs/SimpleCalendar";
import AffairsSection from "@/components/affairs/AffairsSection";
import calendarEventsMixin from "@/mixins/calendarEvents"
import vSelect from 'vue-select'
import axios from '@/axios'
import moment from "moment";

const DEFAULT_LIMIT_VALUE = 20

export default {
	mixins: [calendarEventsMixin],

	name: "Affairs",

	components: {
		SimpleCalendar,
		AffairsSection,
		vSelect,
	},

	data() {
		return {
			activePromptAddEvent: false,
			dateFrom: null,
			dateTo: null,
			offset: 0,
			filter: '',
			calendarEvents: []
		};
	},
	computed: {
		canShowAssignButton() {
			return this.$store.getters['isAdmin']
				&& !this.task.is_by_admin
				&& !this.task.is_completed;
		},
		canShowDoneButton() {
			return !this.task.is_completed;
		},
		minDate() {
			return new Date();
		},
		taskDueDate() {
			return moment(this.task.date_time).format("YYYY.MM.DD HH:mm");
		},
		taskList() {
      const arr = [...this.$store.getters['calendar/getEvents']]
			return this.filterTasks(arr);
		},
	},
	methods: {
    async changeFilter(data) {
      this.$store.dispatch('calendar/resetEvents')
      this.offset = 0
      this.filter = data
      this.dateFrom = null
      this.dateTo = null

      if (data === 'byNow') {
        this.dateFrom = moment(new Date()).format('YYYY-MM-DD')
        this.dateTo = moment(new Date()).format('YYYY-MM-DD')
      }

      await this.loadEvents()
    },

		filterTasks(list) {
			// const currentDate = moment(new Date()).format("YYYY-MM-DD");

			// return list.filter(item => {
      //   const tasks = [...item.tasks]
      //   const hasCompletedTasks = tasks.every((el) => el.is_completed)

      //   return !(item.date_time < currentDate && hasCompletedTasks)
			// 	|| (this.filter && hasCompletedTasks)
      // });

      return list
		},
		async tryAddTask() {
      try {
        this.activePromptAddEvent = true;
        const res = await this.addTask()
        this.activePromptAddEvent = !res;
        this.$store.dispatch('calendar/resetEvents')
        await this.loadEvents()
      } catch (err) {
        console.error(err);
      }
		},

    async periodChanged(data) {
      try {
        this.dateFrom = moment(data.periodStart).format('YYYY-MM-DD')
        this.dateTo = moment(data.periodEnd).format('YYYY-MM-DD')
		this.calendarEvents = []
		await this.loadCalendarEvents()
      } catch (err) {
        console.error(err);
        this.setDefaultDatesRange()
      }
    },

    setDefaultDatesRange() {
      const currentDate = moment();

      this.dateFrom = currentDate.clone().startOf('month').format('YYYY-MM-DD');
      this.dateTo = currentDate.clone().endOf('month').format('YYYY-MM-DD');
    },

		async loadEvents() {
			try {
				const actual =
					this.filter === 'current' ||
					(this.dateFrom === this.dateTo && this.filter === 'byNow')


				const filter = {}

				if (actual) {
					filter.actual = 1
				}

				// byNow
				if (this.filter === 'byNow') {
					filter.date_from = this.dateFrom
					filter.date_to = this.dateTo
				}

				if (['support', 'sales', 'payments'].includes(this.filter)) {
					filter[this.filter] = 1
				}

				await this.$store.dispatch('calendar/fetchEvents', {
					filter,
					dateFrom: this.dateFrom,
					dateTo: this.dateTo,
					actual: actual,
					offset: this.offset,
					limit: DEFAULT_LIMIT_VALUE,
				})

				if (!this.taskList.length) {
					this.offset = 0
				}

			} catch (err) {
				console.error(err)
				throw err
			}
		},


		async loadCalendarEvents() {
      try {
		  this.calendarEvents = await this.$store.dispatch('calendar/fetchCalendarEvents', {
			  payload: {
				  dateFrom: this.dateFrom,
				  dateTo: this.dateTo,
			  },
			  showDeadlines: !this.$store.getters['isAdmin']
		  })
      } catch(err) {
        console.error(err);
        throw err
      }
    },

    async lazyLoadEvents(callback) {
      try {
        this.offset += DEFAULT_LIMIT_VALUE

        await this.loadEvents()
        callback()
      } catch (err) {
        console.error(err);
          // FOR RETRY LOAD ITEMS
        setTimeout(() => {
          this.offset -= DEFAULT_LIMIT_VALUE
          callback()
        }, 3000)
      }
    },
	},

	async created() {
		if(this.$store.getters['isAdmin']){
			try {
			let res = 	await axios.get('admin/manager')
				if(res.status===200) this.managersList = res.data.data;
			}
			catch(e){
				console.error(e)
			}
		}
	},
}
</script>

<style scoped lang="scss">
@import "../../assets/scss/vuexy/variables.scss";

.affairs {
	display: flex;
	width: 100%;

	@media screen and (max-width: 1500px){
		flex-wrap: wrap;
	}

	.buttons-block{
		display: flex;
		justify-content: flex-end;
	}
}

.con-exemple-prompt {
	.append-text {
		height: 2.7rem;
	}
	.vs-button {
		border-left: 0;
	}
	.vx-input-group-append {
		align-items: flex-end;
	}
	.vs-input {
		width: 100%;
		textarea {
			resize: none;
		}
	}
}
</style>
